import type { AdminUserListParams } from '../types/admin-user.types';

export const adminUserKeys = {
  all: ['adminUsers'] as const,
  lists: () => [...adminUserKeys.all, 'list'] as const,
  list: (params: AdminUserListParams) =>
    [
      ...adminUserKeys.lists(),
      {
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        status: params.status ?? null,
        searchTerm: params.searchTerm ?? null,
      },
    ] as const,
  details: () => [...adminUserKeys.all, 'detail'] as const,
  detail: (id: string) => [...adminUserKeys.details(), id] as const,
  loginAttempts: (id: string, params: { page: number; pageSize: number }) =>
    [...adminUserKeys.detail(id), 'login-attempts', params] as const,
};
